const ebooks = {
  id: 'ebooks',
  text: 'Unlock more with ebooks',
}

const clubs = {
  id: 'clubs',
  text: 'How clubs work',
}

const faqs = {
  id: 'faqs',
  text: 'FAQs',
}

export const getHeaderLinks = ({ swap }: { swap: boolean }) => {
  const links = [clubs, ebooks, faqs]
  if (swap) links.unshift(links.splice(1, 1)[0])
  return links
}
